import React from 'react';
import { get } from 'lodash';

// React view component to render
import { actionWidgetNotes as ActionWidgetNotesView } from 'ui/views/widgets/actionWidgetNotes';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { ActionWidgetNotesService } from 'services/actionWidgetNotes';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { ActionWidgetNotes } from 'ui/containers/ActionWidgetNotes';
 *
 * // render
 * <ActionWidgetNotes propName='propValue'/>
 */
export class ActionWidgetNotes extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        // create service instance
        this.actionWidgetNotesService = new ActionWidgetNotesService();
        
        // start data fetch
        this.fetchComponentData();
    }

     /**
     * @desc Fetch component response.
     */
    async fetchComponentData() {
        log.debug( 'ActionWidgetNotes.fetchComponentData()' );

        // cancel ongoing request
        this.actionWidgetNotesService.cancel();

        // fetch component data
        const { status, data } = await this.actionWidgetNotesService.fetchComponentData( {
            url: this.props.widget.url,
            data: this.props.requestPayload
        } );

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
            
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
            } );
        }
    }

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.actionWidgetNotesService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <ActionWidgetNotesView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                componentData={ get( this.state, 'componentData', {} ) }
            />
        );
    }
}

// set display name
ActionWidgetNotes.displayName = 'ActionWidgetNotes';

// set default props
ActionWidgetNotes.defaultProps = {};

// prop types
ActionWidgetNotes.propTypes = {};
